/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export class FreeTextConfig {
  value: string;
  isMandatory: boolean;
  placeHolder: string;
  validationType: number;
}
